var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("vue-editor", {
    attrs: { editorToolbar: _setup.customToolbar },
    model: {
      value: _setup.model,
      callback: function ($$v) {
        _setup.model = $$v
      },
      expression: "model",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }